import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ab1ec10"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["skeleton-image", _ctx.className])
  }, [
    _withDirectives(_createElementVNode("img", {
      ref: "img",
      class: "skeleton-image-img",
      src: _ctx.src,
      alt: _ctx.alt,
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoad && _ctx.onLoad(...args))),
      onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onError && _ctx.onError(...args)))
    }, null, 40, _hoisted_1), [
      [_vShow, _ctx.state === 'loaded']
    ]),
    (_ctx.state !== 'loaded')
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["skeleton-image-placeholder", _ctx.state === 'error' ? 'is-error' : 'is-loading']),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true)
  ], 2))
}